export enum CustomerGroup {
  DIRECT = 'DIRECT',
  SID = 'SID',
  UNINRW = 'UNINRW',
}
